import React from "react";
import { PongSpinner } from "react-spinners-kit";



export const Spiner = () => <div className='spinner-div' >
    <div className='inner-spiner-div'>
        <PongSpinner
            size={100}
            color="#ffffff"
        />
        <span className='span-spinner' >لطفا منتظر بمانید در حال دریافت اطلاعات ...</span>
    </div>
</div>
